export default {
  v: '5.9.4',
  fr: 24,
  ip: 0,
  op: 56,
  w: 64,
  h: 64,
  nm: 'loading',
  ddd: 0,
  assets: [
    {
      id: 'image_0',
      w: 64,
      h: 64,
      u: '',
      p:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAABAAAAAQBPJcTWAAAAJHpUWHRDcmVhdG9yAAAImXNMyU9KVXBMK0ktUnBNS0tNLikGAEF6Bs5qehXFAAACvElEQVR4nO2ZwYtNURzHP+c9Y5oZMpOZ0TBsxlAsRigLKzWKYoFS/gl7GxtrxR8gJcVSSvkDlLJEGFkoZhYYSmNKho/FO6PX6zHG3HuN5/epU69z7/n9vud3f+ec370PguC/JlXhRF0PjAKbchsA1gFdwJrcvgAfgTfAa2AqpfS2bG2lBEDtAoaBMWAc2AgsAJ+BOeBT/r0A1IEeYEMesxkYzO0d8AC4BzxOKc0XrbXQAKhrgR3AdhqTmQNeAjPAe2A+pbSwhI0uoB/YBuwFDmV7r4G7wM2U0seiNBcSgDzx7cDObHMaeJ5S+lCQ/THgNHCERqZcB66mlGaLsL8i1BH1kHpM3a32lOhrWD2rPlLvq6fK8vU7YrrzhA+rE2p3hb43qpfUGfWquqUq34sCetV96kF1UK3kNGnRUM/Bf5EzYqIqx/3q/vz011bi9Nd6RtTb6nv1ZNnONqh71DG1XqqzZaD2qdfUOfVEWU7Wq7vULX8j5ZdC7VIv5iAUmwl5wxtXR1fj5BfJQbimfihsT8ibzdY8+VohRkskL4c76tNCTod85GxT1xSgrxLUzeq0emOlhnryky+tuCkL9ag6r575UwO1fMYPFKytEvLSvaJOqUN/YqA3l56rft3/DHVInVUvLHdgUgfUvpK0VYZ6PhdJ/csZ1J0rvn/26S+SK8VX6rnlDOpTe0vUVSnqZfWhuu53bq7nqm/VlLorJb+3fFEnW6+1S/Ea8C2l9LV8aZXxBHgGHG+90C4AdRofKDuGlJLALeDYkjfn4qdj0n8RdVL9qo4299dabqoBAt+qFFcRUzS+Mh9o7my3BMwp02m8yW13c2drABKNDOg4UkqfaXyiH2/ub5sBVQj6S0wDI80d/1sAZmn8r/CDdkugk5mn8+cYBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEL3wEPVd8PqpNRFAAAAABJRU5ErkJggg==',
      e: 1
    }
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 2,
      nm: 'loading_00000.png',
      cl: 'png',
      refId: 'image_0',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0] },
            { t: 55, s: [720] }
          ],
          ix: 10
        },
        p: { a: 0, k: [32, 32, 0], ix: 2, l: 2 },
        a: { a: 0, k: [32, 32, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 }
      },
      ao: 0,
      ip: 0,
      op: 56,
      st: 0,
      bm: 0
    }
  ],
  markers: []
}



// WEBPACK FOOTER //
// ./packages/dof-spinner/colmo_loading.js